export enum ShotFrom {
  Unknown = 0,
  Fairway = 1,
  FairwayBunker = 2,
  GreensideBunker = 3,
  Tee = 4,
  Green = 5,
  LeftRough = 6,
  RightRough = 7,
  Hazard = 8,
  Other = 9,
  GreensideRough = 10,
  Fringe = 11
}

export enum ShotType {
  Normal = 1,
  Provisional = 2,
  Penalty = 3,
  Drop = 4
}
